module.exports = __webpack_public_path__ + "img/screenshot-2.dceb8da8.webp";